import { VerdictBlock } from 'components/common/Verdict/Verdict';

import {
  CandidateDetailsAction,
  ResolutionPassedByCandidateDetailsAction,
  ResolutionTextByCandidateDetailsAction,
} from '@constants';

export const ResolutionBlock: React.FC<{
  candidateDetailsAction: CandidateDetailsAction | null;
}> = ({ candidateDetailsAction }) => {
  if (!candidateDetailsAction) return null;

  const passed =
    ResolutionPassedByCandidateDetailsAction[candidateDetailsAction];
  const label = ResolutionTextByCandidateDetailsAction[candidateDetailsAction];

  if (passed === undefined || !label) return null;

  return <VerdictBlock passed={passed} label={label} />;
};
